import numberFormat from './numberFormat';

export default function PercentageFormat(num: number) {
    return `${numberFormat(num)}%`;
}
